


































import { Component, Vue, Prop } from "vue-property-decorator";
import MainHeader from "../../../main/components/main-header/main-header.vue";
import { GetCenter } from "@/request/zhuanbingshujuku";
import { GetImageCate1 } from "@/request/home";
@Component({
  components: {
    MainHeader,
  },
})
export default class Shouye extends Vue {
  private centers: any = {};
  private list: any = [];
  private loading: any = false;
  /**
   * @description 获得专病数据库列表
   */
  private getCenterList() {
    GetCenter(this).then((data: any) => {
      this.loading = true;
      this.centers = data[0];
      this.$store.commit("updateCenter", data[0]);
      this.getImageCate1();
    });
  }
  /**
   * @description 获取图片采集一级目录列表
   */
  private getImageCate1() {
    const params = {
      params: {
        project_id: this.centers.project_id,
      },
    };
    GetImageCate1(this, params).then((data: any) => {
      this.list = data;
      this.loading = false;
    });
  }
  private goTupianDetail(item) {
    this.$router.push({
      path: "/main/home/tupian",
      query: {
        cateName: item.dir_name,
        cateId: item.id,
      },
    });
  }
  /**
   * @description 初始化
   */
  private mounted() {
    this.getCenterList();
  }
}
